module.exports = "../fonts/airo-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/airo-logo.svg
// module id = 416
// module chunks = 0